import {remCalc} from '../../_utils'

/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: {
        drawerBody: {
            px: {base: remCalc(16), sm: remCalc(24), md: remCalc(25)},
            py: {base: remCalc(20), sm: remCalc(30), md: remCalc(40)},
        },
        drawerHeader: {
            p: 0,
            pb: remCalc(21),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            w: '100%',
        },
        breadcrumbContainer: {gap: remCalc(10), align: 'center'},
        breadcrumbText: {
            textStyle: 'body-small',
            fontWeight: 'normal',
            lineHeight: 'unset',
        },
        firstLevelGrid: {
            gap: {base: remCalc(24), md: remCalc(32)},
            pt: {base: remCalc(21), md: remCalc(16)},
        },
        firstLevelSecondaryGrid: {
            columns: 2,
            gap: {base: remCalc(8), sm: remCalc(16), md: remCalc(24)},
        },
        headerLinks: {gap: {base: remCalc(8), sm: remCalc(16), md: remCalc(24)}},
        headerIconSize: {boxSize: 'iconsSize.small'},
        svgContainer: {
            h: remCalc(36),
            w: remCalc(36),
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'background.light-blue',
        },
        secondaryCardsGrid: {gap: {base: remCalc(8), sm: remCalc(16), md: remCalc(24)}},
        secondLevelContainer: {
            pt: {base: remCalc(21)},
            maxW: 'container.xxl',
            m: 'auto',
            direction: 'column',
        },
        secondLevelExploreAll: {
            borderRadius: 'full',
            w: '100%',
            mb: {base: remCalc(24), md: remCalc(32)},
        },
        secondLevelGrid: {gap: remCalc(24)},
    },
    parts: [],
}
